import React, { useState } from 'react';
import { submitForm } from '../utils/api';
import './FormPage.css';

// Create a simplified registration form component for testing
const Form = ({ formData, onSubmit }) => {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    
    setError('');
    onSubmit({ username, email, password });
  };
  
  return (
    <div className="form-container">
      <h2>{formData.title || 'Registration Form'}</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-field">
          <label>Username</label>
          <input 
            type="text" 
            value={username} 
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-field">
          <label>Email</label>
          <input 
            type="email" 
            value={email} 
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-field">
          <label>Password</label>
          <input 
            type="password" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <div className="form-field">
          <label>Confirm Password</label>
          <input 
            type="password" 
            value={confirmPassword} 
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>
        {error && <div className="form-error">{error}</div>}
        <button type="submit">Register</button>
      </form>
    </div>
  );
};

const RegistrationFormPage = () => {
  const [apiEnvironment, setApiEnvironment] = useState('simulation');
  const [submissionResult, setSubmissionResult] = useState(null);
  
  const registrationFormData = {
    title: 'Create Your Account',
    description: 'Sign up to access our services'
  };
  
  const handleSubmit = async (formValues) => {
    console.log('Registration form values:', formValues);
    
    try {
      // Submit to the selected API environment
      const result = await submitForm('registration', formValues, null, apiEnvironment);
      console.log('Submission result:', result);
      setSubmissionResult(result);
      return result;
    } catch (error) {
      console.error('Submission error:', error);
      setSubmissionResult({
        success: false,
        message: error.message || 'An unknown error occurred'
      });
      throw error;
    }
  };
  
  return (
    <div>
      <h1 className="page-title">Registration Form Example</h1>
      
      <div className="page-description">
        <p>This example demonstrates a comprehensive account registration form with validation rules. Registration forms are essential for user onboarding in applications and services.</p>
      </div>
      
      <div className="form-options">
        <div className="option-group">
          <label htmlFor="api-environment">API Environment:</label>
          <select
            id="api-environment"
            value={apiEnvironment}
            onChange={(e) => setApiEnvironment(e.target.value)}
          >
            <option value="simulation">Simulation (No API)</option>
            <option value="local">Local API (http://localhost:8787)</option>
            <option value="production">Production API</option>
          </select>
        </div>
      </div>
      
      {submissionResult && (
        <div className={`submission-result ${submissionResult.success ? 'success' : 'error'}`}>
          <h3>{submissionResult.success ? 'Registration Successful' : 'Registration Failed'}</h3>
          <p>{submissionResult.message}</p>
          {submissionResult.id && <p>Reference ID: {submissionResult.id}</p>}
        </div>
      )}
      
      <div className="form-container-wrapper">
        <Form
          formData={registrationFormData}
          onSubmit={handleSubmit}
        />
      </div>
    </div>
  );
};

export default RegistrationFormPage; 